import { createWebHistory } from 'vue-router'
import { createRouter } from 'vue-router'
import MandantenApp from '@/components/MandantenApp'

export default createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'development' ? '/mandanten-app/#/' : '/mandanten-app.html#/'),
  linkExactActiveClass: 'linkExactActiveClass',
  linkActiveClass: 'linkActiveClass',
  routes: [
    {
      path: '/',
      redirect: '/vertraege'
    },
    {
      path: '/login',
      name: 'Login',
      component: MandantenApp
    },
    {
      path: '/profil',
      name: 'Profil',
      component: MandantenApp
    },
    {
      path: '/vertraege',
      name: 'Verträge',
      component: MandantenApp
    },
    {
      path: '/vertrag/:vertrag_id',
      name: 'Vertrag',
      component: MandantenApp
    },
    {
      path: '/vertrag/:vertrag_id/anlage-v/:jahr',
      name: 'Anlage-V',
      component: MandantenApp
    },
    {
      path: '/kontakt',
      name: 'Kontakt',
      component: MandantenApp
    },
    {
      path: '/nachrichten',
      name: 'Nachrichten',
      component: MandantenApp
    },
    {
      path: '/empfehlungen',
      name: 'Empfehlungen',
      component: MandantenApp
    },
    {
      path: '/:pathMatch(.*)*',
      component: MandantenApp,
      name: 'Startseite'
    }
  ]
})
